import { IResponse } from '../types/response.type'
import { axiosInstance } from './axios.service'
import { UserEndpoints } from '../types/endpoint.type'
import { IRole, IUser } from '../../shared/types/api/user.type'

export const getUsers = async (): Promise<IResponse<IUser[]>> => {
  try {
    const data = await axiosInstance.get(UserEndpoints.USERS)

    return data.data
  } catch (err: any) {
    return {
      success: false,
      message: err?.response?.data?.message ?? err.message,
    }
  }
}

export const deleteUser = async (userId: string): Promise<IResponse<null>> => {
  try {
    const data = await axiosInstance.delete(`${UserEndpoints.USERS}${userId}`)

    return data.data
  } catch (err: any) {
    return {
      success: false,
      message: err?.response?.data?.message ?? err.message,
    }
  }
}

export const updateUserData = async (
  userData: IUser & { password?: string; password_confirmation?: string },
  roles: IRole[],
): Promise<IResponse<IUser>> => {
  try {
    // Match the TypeORM-shaped User: roles live on the user as a relation.
    const body = { ...userData, roles: roles.map((r) => ({ id: r.id })) }
    const url = userData.id ? `${UserEndpoints.USERS}${userData.id}` : UserEndpoints.USERS
    const data = await axiosInstance.post(url, body)

    return data.data
  } catch (err: any) {
    return {
      success: false,
      message: err?.response?.data?.message ?? err.message,
    }
  }
}

export const getRolesAndPermissions = async (): Promise<IResponse<IRole[]>> => {
  try {
    const resp = await axiosInstance.get(UserEndpoints.UPDATE_ROLES)

    return resp.data
  } catch (err: any) {
    return {
      success: false,
      message: err?.response?.data?.message ?? err.message,
    }
  }
}

export const createRole = async (role: {
  name: string
  permissions?: IRole['permissions']
}): Promise<IResponse<IRole>> => {
  try {
    const resp = await axiosInstance.post(`${UserEndpoints.USERS}roles`, role)
    return resp.data
  } catch (err: any) {
    return {
      success: false,
      message: err?.response?.data?.message ?? err.message,
    }
  }
}

export const updateRole = async (
  id: string,
  role: { name?: string; permissions?: IRole['permissions'] },
): Promise<IResponse<IRole>> => {
  try {
    const resp = await axiosInstance.post(`${UserEndpoints.USERS}roles/${id}`, role)
    return resp.data
  } catch (err: any) {
    return {
      success: false,
      message: err?.response?.data?.message ?? err.message,
    }
  }
}

export const deleteRole = async (id: string): Promise<IResponse<null>> => {
  try {
    const resp = await axiosInstance.delete(`${UserEndpoints.USERS}roles/${id}`)
    return resp.data
  } catch (err: any) {
    return {
      success: false,
      message: err?.response?.data?.message ?? err.message,
    }
  }
}
